import { render, staticRenderFns } from "./QuickUploadAddressPictureDialog.vue?vue&type=template&id=5b5d13ba&"
import script from "./QuickUploadAddressPictureDialog.vue?vue&type=script&lang=js&"
export * from "./QuickUploadAddressPictureDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports